import type {
  ActionButton,
  FormField,
} from '@shared/components/add-form/add-form.component';

export const OFFER_HEADER_ACTIONS: ActionButton[] = [
  {
    label: 'common.actions.cancel',
    action: 'cancel',
    outlined: true,
    severity: 'secondary',
  },
  {
    label: 'common.actions.save',
    action: 'save',
    severity: 'info',
  },
];

// Only kinds the promotion-engine actually evaluates. PURCHASE_WITH_PURCHASE
// exists in backend OfferKind but is intentionally hidden from the UI.
export const OFFER_TYPE_OPTIONS: { label: string; value: string }[] = [
  { label: 'offer.type.periodic_discount', value: 'PERIODIC_DISCOUNT' },
  { label: 'offer.type.multibuy', value: 'MULTIBUY' },
  { label: 'offer.type.total_discount', value: 'TOTAL_DISCOUNT' },
  { label: 'offer.type.line_discount', value: 'LINE_DISCOUNT' },
  { label: 'offer.type.tender', value: 'TENDER' },
  { label: 'offer.type.mix_match', value: 'MIX_MATCH' },
];

export const OFFER_STATUS_OPTIONS: { label: string; value: string }[] = [
  { label: 'offer.status.draft', value: 'DRAFT' },
  { label: 'offer.status.active', value: 'ACTIVE' },
  { label: 'offer.status.inactive', value: 'INACTIVE' },
];

/** Base form: Basic info + Common settings (Configuration is loaded from API). */
export const OFFER_BASE_FORM_FIELDS: FormField[] = [
  {
    label: 'offer.form.fields.code',
    controlName: 'code',
    type: 'text',
    placeholder: 'offer.form.placeholders.code',
    required: true,
    maxLength: 64,
    section: 'offer.form.sections.basic',
  },
  {
    label: 'offer.form.fields.type',
    controlName: 'offerType',
    type: 'dropdown',
    placeholder: 'offer.form.placeholders.type',
    required: true,
    options: OFFER_TYPE_OPTIONS,
    section: 'offer.form.sections.basic',
  },
  {
    label: 'offer.form.fields.name',
    controlName: 'offerName',
    type: 'text',
    placeholder: 'offer.form.placeholders.name',
    required: true,
    maxLength: 200,
    section: 'offer.form.sections.basic',
  },
  {
    label: 'offer.form.fields.description',
    controlName: 'description',
    type: 'text',
    placeholder: 'offer.form.placeholders.description',
    maxLength: 500,
    section: 'offer.form.sections.basic',
    colSpan: 2,
  },
  {
    label: 'offer.form.fields.status',
    controlName: 'status',
    type: 'dropdown',
    placeholder: 'offer.form.placeholders.status',
    required: true,
    options: OFFER_STATUS_OPTIONS,
    section: 'offer.form.sections.basic',
  },
  {
    label: 'offer.form.fields.start_date',
    controlName: 'startDate',
    type: 'date',
    placeholder: 'offer.form.placeholders.start_date',
    required: true,
    section: 'offer.form.sections.common',
    sectionGridCols: 4,
  },
  {
    label: 'offer.form.fields.end_date',
    controlName: 'endDate',
    type: 'date',
    placeholder: 'offer.form.placeholders.end_date',
    required: true,
    section: 'offer.form.sections.common',
    sectionGridCols: 4,
  },
  {
    label: 'offer.form.fields.start_time_daily',
    controlName: 'startTime',
    type: 'date',
    placeholder: 'offer.form.placeholders.start_time_daily',
    section: 'offer.form.sections.common',
    sectionGridCols: 4,
    showTime: true,
    timeOnly: true,
    showSeconds: true,
    hourFormat: '24',
  },
  {
    label: 'offer.form.fields.end_time_daily',
    controlName: 'endTime',
    type: 'date',
    placeholder: 'offer.form.placeholders.end_time_daily',
    section: 'offer.form.sections.common',
    sectionGridCols: 4,
    showTime: true,
    timeOnly: true,
    showSeconds: true,
    hourFormat: '24',
  },
  {
    label: 'offer.form.fields.stackable',
    controlName: 'stackable',
    type: 'checkbox',
    section: 'offer.form.sections.common',
    sectionGridCols: 4,
    defaultValue: true,
  },
  // priority + salesChannelCodes hidden: engine does not yet honor priority
  // ordering or sales-channel filtering. Re-add when the engine supports them.
];

export const OFFER_FORM_FIELDS: FormField[] = [...OFFER_BASE_FORM_FIELDS];
